<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Alarms</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Alarms -->
  <button mat-raised-button (click)="refreshAsync()">Refresh</button>
  <h3>
    <span class="greenAlarm">OK: {{greenAlarms?.length}}</span>
    <span>&nbsp;</span>
    <span class="redAlarm">ALARM: {{redAlarms?.length}}</span>
    <span>&nbsp;</span>
    <span class="pendingAlarm">PENDING: {{pendingAlarms?.length}}</span>
  </h3>

  <!-- Alarms grid -->
  <div class="alarmGridContainer">
    <ag-grid-angular #agGrid class="ag-theme-alpine alarmGrid" [gridOptions]="alarmGridOptions">
    </ag-grid-angular>
  </div>

  <!-- Selected alarm -->
  <div *ngIf="selectedAlarm">
    <p>
      <strong>Alarm Details</strong>
    </p>
    <pre>{{selectedAlarm | json}}</pre>
  </div>
</div>